import { useState } from "react";

import type { Meta, StoryObj } from "@storybook/react";

import { CalendarType } from "@/constants/Calendar";
import DisableCalendarSyncConfirmationAlert from "@/ui/components/calendarSync/DisableCalendarSyncConfirmationAlert";
import { Button } from "@/ui/core";
import { Box, VStack } from "@/ui/layout";

interface StoryProps {
  calendarType: CalendarType;
  onConfirm: () => void;
  onDismiss: () => void;
}

const StoryMeta: Meta<StoryProps> = {
  title: "Components/Calendar Sync/Disable Confirmation Alert",
  component: DisableCalendarSyncConfirmationAlert,
  argTypes: {
    calendarType: {
      control: "select",
      options: [CalendarType.Apple, CalendarType.Google],
    },
    onConfirm: { action: "confirmed" },
    onDismiss: { action: "dismissed" },
  },
  args: {
    calendarType: CalendarType.Google,
  },
  // eslint-disable-next-line no-restricted-syntax -- non-arrow function used here as React FC needed for use of state hook
  render: function Render({ calendarType, onConfirm, onDismiss }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
      <Box padding={20} width="100%">
        <VStack gap={16}>
          <Button
            onPress={() => setIsOpen(true)}
            testID="storybook-trigger"
            title="Click to open modal"
          />
          <DisableCalendarSyncConfirmationAlert
            calendarType={calendarType}
            isOpen={isOpen}
            onConfirm={() => {
              setIsOpen(false);
              onConfirm();
            }}
            onDismiss={() => {
              setIsOpen(false);
              onDismiss();
            }}
          />
        </VStack>
      </Box>
    );
  },
};

type Story = StoryObj<StoryProps>;

const GoogleCalendar: Story = {
  args: {
    calendarType: CalendarType.Google,
  },
};

const DeviceCalendar: Story = {
  args: {
    calendarType: CalendarType.Apple,
  },
};

export { DeviceCalendar, GoogleCalendar };
export default StoryMeta;
